export default "__VITE_PUBLIC_ASSET__bd00d80d__"